import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  DescriptionContainer,
  ImageContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { TrapezoidalChannelVM } from './TrapezoidalChannelVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';


const TrapezoidalChannelComponent = (props) => {
  const vm = useRef(new TrapezoidalChannelVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_Trapezoid Channel_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer computeCallback={() => {vm.computefnTrapezodial()}} printCallback={() => vm.launchAndExport()} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={vm.disablePrintBtn}>
          <span className="input-help-header">
           Not for Grassed Waterway Design<a href={vm.helpLink} target='_blank'>Help select n value <img src={pdfLogo} alt={'PDF logo'} /> 
           </a>
          </span>
          <h2 className='sections-heading'>General</h2>
          <Input
            label="Bottom Width (ft)"
            idAndName="bottom-width"
            valid={!vm.formValidation.bottomWidth}
            value={vm.trapezodialFormData.bottomWidth}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('bottomWidth')}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
          />
          <Input 
            label="Depth (ft)" 
            idAndName="depth" 
            valid={!vm.formValidation.depth} 
            value={vm.trapezodialFormData.depth} 
            type="number" 
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('depth')}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            />
          <Input
            label="Side Slope 'Z1' (ft/ft)"
            idAndName="side-slope-z1"
            valid={!vm.formValidation.sideSlopeZ1}
            value={vm.trapezodialFormData.sideSlopeZ1}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('sideSlopeZ1')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Side Slope 'Z2' (ft/ft)"
            idAndName="side-slope-z2"
            valid={!vm.formValidation.sideSlopeZ2}
            value={vm.trapezodialFormData.sideSlopeZ2}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('sideSlopeZ2')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Bed Slope (ft/ft)"
            idAndName="bed-slope"
            valid={!vm.formValidation.bedSlope}
            value={vm.trapezodialFormData.bedSlope}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.0001}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('bedSlope')}
            onKeyDown={vm.handleOnKeyDown}
            min={0.0001}
          />
          <Input 
            label="Manning's n" 
            idAndName="mannings-n" 
            valid={!vm.formValidation.mannings} 
            value={vm.trapezodialFormData.mannings} 
            type="number" 
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.0001}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.TrapezoidalErrorClass('mannings')}
            onKeyDown={vm.handleOnKeyDown}
            min={0.0001}
            />
        </InputContainer>
        <div className="col formula-information">
          {vm.hasResults ? (
            <div className="col formula-results">
              <ResultsContainer>
                <div className="col-auto ">
                  <div className="row">
                    <div className="col-auto result-label">Hydraulic Radius (ft):</div>
                    <div className="col-auto result-value">{vm.calculationResults.hydraulicRadius}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Top Width (ft):</div>
                    <div className="col-auto result-value">{vm.calculationResults.topWidth}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Area (sq ft):</div>
                    <div className="col-auto result-value">{vm.calculationResults.area}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Capacity Q (cfs):</div>
                    <div className="col-auto result-value">{vm.calculationResults.capacityQ}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Velocity (ft/sec):</div>
                    <div className="col-auto result-value">{vm.calculationResults.valocity}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Critical Depth (ft):</div>
                    <div className="col-auto result-value">{vm.calculationResults.criticalDepth}</div>
                  </div>
                </div>
              </ResultsContainer>
            </div>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img
                className="trapezoid-img"
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer 
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const TrapezoidalChannelFormula = observer(TrapezoidalChannelComponent);
